module.exports = __webpack_public_path__ + "img/course-img.68e264e0.png";